/**
 * Class description
 *
 * Created: 2020-07-08
 * @author Jie
 */
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite, Timeline} from "gsap";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {WinterHoardGameConfig} from "../../WinterHoardGameConfig";
import {WinterHoardParsedGameData} from "../../server/data/IWinterHoardServerData";

export class SymbolAttention implements GameRoundPresentation {

    private _tl: TimelineLite;

    constructor() {

    }


    public getAnimation(data: SpinParsedGameData): Timeline | null {
        if (!data.freespinTriggeredThisSpin) {
            return null;
        }
        const tl: TimelineLite = new TimelineLite();
        data.scatterPositions!.forEach((pos: number, i: number) => {
            tl.add(Reels.getSymbol(i, pos)!.changeState({
                state: WinterHoardGameConfig.instance.SYMBOL_STATES.trigger
            }), 0);

        });
        tl.add(() => {}, 0.67);
        this._tl = tl;
        return tl;

    }

    public abort(isActive: boolean, data: WinterHoardParsedGameData): Timeline {
        const tl: TimelineLite = new TimelineLite();
        if (isActive && this._tl) {
            this._tl.pause();
            this._tl.kill();
        }
        return tl;
    }
}